import { useQuery } from '@tanstack/solid-query'
import ky from 'ky'
import { timestamp } from '~/lib/params'

export const useTimestamp = () => {
  const query = useQuery(() => ({
    queryKey: ['timestamp'],
    queryFn: async () => {
      const res = await ky.get('/time.js?')
      return new Date(Number(new URL(res.url).searchParams.get('ts')) * 1000)
    },
    refetchInterval: import.meta.env.DEV ? false : 30 * 1000,
    staleTime: Infinity,
    initialData: timestamp,
  }))
  return () => query.data
}
